import request from "@/util/http";
import qs from "qs"; // 服务列表查询

export var getServePage = function getServePage(params) {
  return request({
    url: "/admin/serve/page",
    method: "get",
    params: params
  });
}; // 服务单个删除

export var handleServeDelete = function handleServeDelete(id) {
  return request({
    url: "/admin/serve/delete/".concat(id),
    method: "delete"
  });
}; // 服务详情

export var getServeInfo = function getServeInfo(id) {
  return request({
    url: "/admin/serve/get/".concat(id),
    method: "get"
  });
}; // 保存服务

export var hallSaveOrUpdate = function hallSaveOrUpdate(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/serve/saveOrUpdate",
    method: "post",
    data: JSON.stringify(data)
  });
}; // 启用禁用

export var useOrDisuse = function useOrDisuse(params) {
  return request({
    url: "/admin/serve/useOrDisuse",
    method: "post",
    params: params
  });
};